import { TimerSandCompleteIcon } from './TimerSandCompleteIcon';

/**
 * author: Jeff Anders
 * id A3EC03DF-2DAD-4B48-AFA8-681324AE2460
 * name timer-sand-complete
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-sand-complete.svg
 * tags
 * - Date / Time 
 */
export const HourglassCompleteIcon = TimerSandCompleteIcon;
export default HourglassCompleteIcon